import { css } from "@compiled/react";

import GlobalNavigation from "@/patterns/global-nav/src/index";

import { ParentScrollTracking } from "../../../../utils/scroll-tracking";
import {
    JswCollaborateSection,
    AiSection,
    JswDoubleFeatureSection,
    TestimonialSection,
    ClosingBanner,
    BuildAndSupportDoubleFeatureSection,
    IntegrationsSection,
    HeroSection,
    LogoBanner,
    AirCanadaLogo,
    CanvaLogo,
    DominosLogo,
    FordLogo,
    NasaLogo,
    VisaLogo
} from "../sections/ATLAS-55799";
import { Footer } from "../sections/ATLAS-55799/footer";
import JiraSoftwareNav from "../sections/productionized/software-jira-navbar";

export const Atlas55799ProductTourOverview = () => {
    const sectionContainerStyles = css({
        display: "flex",
        flexDirection: "column"
    });
    const overflowXhidden = css({
        overflowX: "hidden"
    });

    const closingBannerContent = {
        text: "No matter what you're trying to dream up, Jira helps you get it done",
        imgUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp",
        altText: "hand image ",
        starImageUrl:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp",
        starsAltText: "star image",
        buttonText: "Get Jira free",
        ctaButtonUrl: "/try/cloud/signup?bundle=jira-software"
    };

    const svgArray = [
        NasaLogo,
        AirCanadaLogo,
        VisaLogo,
        CanvaLogo,
        DominosLogo,
        FordLogo
    ];

    return (
        <div css={overflowXhidden}>
            <div>
                <GlobalNavigation
                    showTryNow={false}
                    color={"#f4f5f7"}
                    productKey="jiraSoftware"
                />
            </div>
            <JiraSoftwareNav />
            <div css={sectionContainerStyles}>
                <ParentScrollTracking
                    scrollTrackingEnabled={true}
                    pageId="Jira"
                >
                    <HeroSection />
                    <LogoBanner svgArray={svgArray} />
                    <JswCollaborateSection />
                    <AiSection />
                    <BuildAndSupportDoubleFeatureSection />
                    <JswDoubleFeatureSection />
                    <IntegrationsSection />
                    <TestimonialSection />
                    <ClosingBanner {...closingBannerContent} />
                    <Footer />
                </ParentScrollTracking>
            </div>
        </div>
    );
};
